var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tag-list":""}},_vm._l((_vm.tags),function(tag){return _c('a',{key:tag,class:{on: _vm.value === tag},on:{"click":function($event){return _vm.$emit('input', tag)}}},[_c('s',[_vm._v(_vm._s(tag))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }